import { render } from "./CommunityPublicationCollaborationAds.vue.js?vue&type=template&id=669d49fa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublicationCollaborationAds.vue?vue&type=template&id=669d49fa"
import script from "./CommunityPublicationCollaborationAds.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublicationCollaborationAds.vue?vue&type=script&lang=js"
export * from "./CommunityPublicationCollaborationAds.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublicationCollaborationAds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/CommunityPublicationCollaborationAds.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "669d49fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('669d49fa', __exports__)) {
    api.reload('669d49fa', __exports__)
  }
  
  module.hot.accept("./CommunityPublicationCollaborationAds.vue.js?vue&type=template&id=669d49fa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublicationCollaborationAds.vue?vue&type=template&id=669d49fa", () => {
    api.rerender('669d49fa', render)
  })

}


export default __exports__